import { render, staticRenderFns } from "./ItemSizes.vue?vue&type=template&id=5386f78a&scoped=true&"
import script from "./ItemSizes.vue?vue&type=script&lang=js&"
export * from "./ItemSizes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5386f78a",
  null
  
)

export default component.exports